import { render, staticRenderFns } from "./dniFooter.vue?vue&type=template&id=58c06cf4&"
import script from "./dniFooter.vue?vue&type=script&lang=js&"
export * from "./dniFooter.vue?vue&type=script&lang=js&"
import style0 from "./dniFooter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports